// src/data/users.js
// Las credenciales se validan en el servidor (netlify/functions/loginUser.js)
// Las contraseñas se configuran como variables de entorno en Netlify

// Definición de roles
export const ROLES = {
  ADMIN: 'admin',
  ATENCION_CLIENTE: 'atencion_cliente',
  COORDINADOR_OPERACIONES: 'coordinador_operaciones'
};

// Mapeo de document-state-id a información del estado
export const DOCUMENT_STATES = {
  651457: { name: 'Pendiente', role: 'coordinador_operaciones', task: 'Contactar al cliente, pedir disculpas y reprogramar con urgencia' },
  1004686: { name: 'Garantía', role: 'coordinador_operaciones', task: 'Verificar por qué la orden no se ha cerrado' },
  1016219: { name: 'Cobrado', role: 'coordinador_operaciones', task: 'Crear factura y enviar al cliente' },
  1018827: { name: 'En ruta', role: 'coordinador_operaciones', task: 'Verificar por qué no se ha cerrado la orden' },
  1016221: { name: 'Pendiente de sustitución', role: 'atencion_cliente', task: 'Crear pegatina · Realizar informe y tramitar sustitución' },
  651446: { name: 'Rechazado', role: null, task: null }, // Sin acción
  1007173: { name: 'Pendiente de pago', role: 'atencion_cliente', task: 'Reclamar el cobro' },
  1016220: { name: 'Ausente', role: 'coordinador_operaciones', task: 'Contactar al cliente, pedir disculpas y reprogramar con urgencia' },
  1016222: { name: 'Pendiente de material', role: 'coordinador_operaciones', task: 'Verificar disponibilidad de material y si no, crear pedido a proveedor' },
  1040205: { name: 'Pendiente de presupuesto', role: 'coordinador_operaciones', task: 'Enviar presupuesto al cliente' },
  1041994: { name: 'PRE LIQUIDACION ARISTON', role: 'atencion_cliente', task: 'Revisar para liquidación' },
  1069430: { name: 'PM', role: 'coordinador_operaciones', task: 'Verificar por qué no se ha cerrado' },
  1069646: { name: 'PRE LIQUIDACION NOFER', role: 'atencion_cliente', task: 'Revisar para liquidación' },
  1069647: { name: 'PRE LIQUIDACION SVAN', role: 'atencion_cliente', task: 'Revisar para liquidación' },
  1070405: { name: 'PRE LIQUIDACION LOGMAN', role: 'atencion_cliente', task: 'Revisar para liquidación' },
  1042425: { name: 'GARANTIA 3', role: null, task: null },
  1073018: { name: 'G4', role: null, task: null },
  1226452: { name: 'PRE LIQUIDACION BERETTA', role: 'atencion_cliente', task: 'Revisar para liquidación' },
  651428: { name: 'Cerrado', role: null, task: null }, // ✅ SIN ACCIÓN - No aparecerá en tareas
  1305009: { name: 'Instalación', role: 'coordinador_operaciones', task: 'Verificar por qué no se ha cerrado' }
};